// typescript will complain window is undefined unless explicitly checked first
export function localStorage() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.localStorage;
}
